import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import EditTaskModal from "../TaskModals/EditTaskModal";
import DeleteTaskModal from "../TaskModals/DeleteTaskModal";

const TaskBoard = ({ projectId, refreshKey }) => {
  const [tasks, setTasks] = useState([]);
  const [statuses, setStatuses] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [hoveredTask, setHoveredTask] = useState(null); // 👈 Track hovered task
  const navigate = useNavigate(); // 👈 Hook for navigation
  const [taskToEdit, setTaskToEdit] = useState(null);
  const [taskToDelete, setTaskToDelete] = useState(null);

  const user = JSON.parse(localStorage.getItem("user"));
  const userRole = user?.role;

  const handleTaskUpdated = (updatedTask) => {
    setTasks((prevTasks) =>
      prevTasks.map((t) => (t.id === updatedTask.id ? updatedTask : t))
    );
  };

  const handleTaskDeleted = (deletedTaskId) => {
    setTasks((prevTasks) => prevTasks.filter((t) => t.id !== deletedTaskId));
  };

  useEffect(() => {
    const authToken = localStorage.getItem("auth_token");

    Promise.all([
      fetch(`https://loopsneller.com/api/tasks?project_id=${projectId}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        },
      }).then((res) => res.json()),
      fetch(`https://loopsneller.com/api/projects/${projectId}/statuses`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        },
      }).then((res) => res.json()),
    ])
      .then(([tasksData, statusesData]) => {
        setTasks(tasksData);
        setStatuses(statusesData);
        setLoading(false);
      })
      .catch((err) => {
        setError("Failed to load tasks or statuses.");
        setLoading(false);
      });
  }, [projectId, refreshKey]);

  if (loading) return <p>Loading tasks...</p>;
  if (error) return <p>Error: {error}</p>;

  // ✅ Fix: Group tasks by status
  const groupedTasks = statuses.reduce((acc, status) => {
    acc[status.name] = tasks.filter((task) => task.status.name === status.name);
    return acc;
  }, {});

  return (
    <div className="card mt-4">
      <div className="card-header">
        <h5>Task Board</h5>
      </div>
      <div className="card-body">
        {statuses.length === 0 ? (
          <p>No statuses defined.</p>
        ) : (
          statuses.map((status) => (
            <div key={status.id} className="mb-3">
              <h6 className="text-primary">{status.name}</h6>
              <ul className="list-group">
                {groupedTasks[status.name]?.length > 0 ? (
                  groupedTasks[status.name].map((task) => (
                    <li
                      key={task.id}
                      className="list-group-item d-flex justify-content-between align-items-center"
                      style={{
                        background:
                          hoveredTask === task.id ? "#E1E1E1" : "white",
                        transition: "background 0.3s",
                      }}
                      onMouseEnter={() => setHoveredTask(task.id)}
                      onMouseLeave={() => setHoveredTask(null)}
                    >
                      {/* Task Info Section */}
                      <div className="flex-grow-1 me-3">
                        <strong>{task.title}</strong>
                        <p className="mb-1">
                          {task.description || "No description"}
                        </p>
                        <small className="text-muted">
                          Assigned to: {task.user.name || "Unassigned"}
                        </small>
                      </div>

                      {/* Button Section */}
                      <div className="d-flex flex-column gap-1 align-items-end">
                        <button
                          className="btn btn-primary btn-sm w-100"
                          onClick={() => navigate(`/tasks/${task.id}`)}
                        >
                          View Task
                        </button>

                        {(userRole === "Admin" || userRole === "Manager") && (
                          <>
                            <button
                              className="btn btn-warning btn-sm w-100"
                              onClick={() => setTaskToEdit(task)}
                            >
                              Edit
                            </button>
                            <button
                              className="btn btn-danger btn-sm w-100"
                              onClick={() => setTaskToDelete(task)}
                            >
                              Delete
                            </button>
                          </>
                        )}
                      </div>
                    </li>
                  ))
                ) : (
                  <li className="list-group-item text-muted">
                    No tasks in this status.
                  </li>
                )}
              </ul>
            </div>
          ))
        )}
      </div>
      <EditTaskModal
        show={!!taskToEdit}
        onClose={() => setTaskToEdit(null)}
        task={taskToEdit}
        statuses={statuses}
        onTaskUpdated={handleTaskUpdated}
      />

      <DeleteTaskModal
        show={!!taskToDelete}
        onClose={() => setTaskToDelete(null)}
        task={taskToDelete}
        onTaskDeleted={handleTaskDeleted}
      />
    </div>
  );
};

export default TaskBoard;
